import * as React from 'react';
import isEqual from 'react-fast-compare';

import { QueryParams, SetActiveIdCallback } from '@/pages/Notifications/notifications.types';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { toggleEmailListSubscription } from '@/redux/modules/account/notifications/emailList/emailList.actions';
import { getNewsletterList } from '@/redux/modules/account/notifications/emailList/emailList.selectors';
import {
    SUBSCRIBE_TO_ALL_EMAIL_LISTS,
    UNSUBSCRIBE_TO_ALL_EMAIL_LISTS,
} from '@/redux/modules/account/notifications/emailList/emailList.types';

import ManageCategoryNotifications from './Components/ManageCategoryNotifications';
import NotificationRow from './Components/NotificationRow';
import Section from './Components/Section';
import StatusCheckbox from './Components/StatusCheckbox';

type Props = {
    activeId: QueryParams['section'];
    setActiveId: SetActiveIdCallback;
};

const Newsletters = ({ activeId, setActiveId }: Props) => {
    const dispatch = useAppDispatch();
    const newsletters = useAppSelector(getNewsletterList);
    const rows = newsletters.map((item) => (
        <NotificationRow
            key={item.code}
            {...item}
        />
    ));
    // insert a manage row second from the end.
    rows.splice(rows.length - 1, 0);

    if (!newsletters.length) {
        return null;
    }

    return (
        <Section
            activeId={activeId}
            component={
                <>
                    {newsletters.map((item) => (
                        <NotificationRow
                            key={item.code}
                            {...item}
                        />
                    ))}
                    <ManageCategoryNotifications />
                </>
            }
            count={newsletters.length}
            email={
                /*  Slice because the last one is an unsubscribe button */
                <StatusCheckbox
                    array={newsletters.slice(0, -1)}
                    category="marketing"
                    onChange={(checked) => {
                        dispatch(
                            toggleEmailListSubscription({
                                code: checked ? UNSUBSCRIBE_TO_ALL_EMAIL_LISTS : SUBSCRIBE_TO_ALL_EMAIL_LISTS,
                            })
                        );
                    }}
                    selector={(newsletter) => newsletter.subscribed}
                    type="email"
                />
            }
            id="newsletters"
            setActiveId={setActiveId}
        />
    );
};

export default React.memo<Props>(Newsletters, isEqual);
